import React, { JSXElementConstructor, ReactElement, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import camelCase from 'camelcase'
import { ContentStateProperty } from '../../../../@types/types'
import ToggleSwitch from '../toggleSwitch/ToggleSwitch'

export interface ToggledInputFieldsProps {
  screenId: string
  elementId: string
  propertyName: ContentStateProperty
  toggleStatus: boolean
  displayChildrenOnToggleState?: boolean
  hasSubtitle?: boolean
  hasRightAlignedToggle?: boolean
  customYAxisOffset: number
  toggleSwitchClassName?: string
  onChange?: (value: boolean) => void
  children: ReactElement<unknown, string | JSXElementConstructor<unknown>>
}

const ToggledInputFields: React.FC<ToggledInputFieldsProps> = ({
  screenId,
  elementId,
  propertyName,
  toggleStatus,
  displayChildrenOnToggleState = true,
  hasSubtitle = false,
  hasRightAlignedToggle,
  toggleSwitchClassName,
  onChange,
  children,
}: ToggledInputFieldsProps) => {
  const [toggleState, setToggleState] = useState(toggleStatus)
  const { t } = useTranslation()

  useEffect(() => setToggleState(toggleStatus), [toggleStatus])

  const doToggle = () => {
    setToggleState((prev) => !prev)
    onChange && onChange(!toggleState)
  }

  const toggleSwitchLabelObject = `wizard.screen.${camelCase(screenId.replace('-screen', ''))}.${camelCase(elementId)}`
  const alignment = hasRightAlignedToggle ? 'right' : hasSubtitle ? 'customWithTitle' : 'custom'

  return (
    <>
      <div className='one-whole float-left'>
        <ToggleSwitch
          id={elementId}
          propertyName={propertyName}
          alignment={alignment}
          label={
            <>
              <span>{t(toggleSwitchLabelObject, elementId.replace('-', ' '))}</span>
              {hasSubtitle && (
                <span className='font-body-medium-regular block'>
                  {t(toggleSwitchLabelObject + 'Subtitle', elementId.replace('-', ' ') + ' subtitle')}
                </span>
              )}
            </>
          }
          value={toggleState}
          className={toggleSwitchClassName}
          onChange={doToggle}
        />
      </div>
      {toggleState === displayChildrenOnToggleState && children && React.cloneElement(children)}
    </>
  )
}

export default ToggledInputFields
